import {buildStandardHeaders, otsBaseApi} from "../../ots-api";
import {ObjectPictureAssoc, ObjectPictureAssocUpload} from "../../../model/object-picture-assoc";
import {BaseQueryApi} from "@reduxjs/toolkit/query";
import {OtsAsyncThunkConfigExtra, OtsState} from "../../ots-store";
import {removeUndefined} from "../../../util/util";

const taggedBaseApi = otsBaseApi.enhanceEndpoints({addTagTypes: ["ObjectPictureAssocs", "ObjectObjectPictureAssocs"]});

const objectPictureAssocApi = taggedBaseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllObjectPictureAssocsByObject: builder.query<ObjectPictureAssoc[], string>({
      query: (objectId) => ({
        url: `/object-picture/all/object/${objectId}`,
        method: "GET",
      }),
      providesTags: (_result, _error, arg, _meta) => {
        return [{type: 'ObjectObjectPictureAssocs', id: arg}];
      },
    }),
    createObjectPictureAssoc: builder.mutation<void, ObjectPictureAssocUpload>({
      query: (objectPictureAssoc) => {
        const formData = new FormData()
        formData.append("file", objectPictureAssoc.file)

        const dto: any = {...objectPictureAssoc}
        dto["@type"] = "ObjectPictureAssoc"
        delete dto["file"]

        formData.append("assoc", new Blob([JSON.stringify(dto)], {
          type: "application/json"
        }))

        return ({
          url: '/object-picture/upload',
          method: 'POST',
          body: formData,
          formData: true
        })
      },
      invalidatesTags: (result, error, arg, meta) => {
        return [
          {type: 'ObjectObjectPictureAssocs', id: arg.objectId},
        ]
      }
    }),
    updateObjectPictureAssoc: builder.mutation<ObjectPictureAssoc, Partial<ObjectPictureAssoc>>({
      query: (objectPictureAssoc) => ({
        url: '/object-picture',
        method: 'PUT',
        body: objectPictureAssoc,
      }),
      invalidatesTags: (result, error, {id, objectId}) => [
        {type: 'ObjectPictureAssocs', id},
        {type: 'ObjectObjectPictureAssocs', id: objectId},
      ],
    }),
    deleteObjectPictureAssoc: builder.mutation<void, Partial<ObjectPictureAssoc>>({
      query: (objectPictureAssoc) => ({
        url: `/object-picture/${objectPictureAssoc.id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, {id, objectId}) => [
        {type: 'ObjectPictureAssocs', id},
        {type: 'ObjectObjectPictureAssocs', id: objectId},
      ],
    }),
  })
});

export const downloadObjectPictures = (objectId: string, api: BaseQueryApi): Promise<Response> => {
  const headers = buildStandardHeaders(api)
  headers["Accept"] = 'application/x-zip'
  headers["Content-Type"] = 'application/x-zip'

  const request: RequestInit = {
    method: 'GET',
    headers: headers,
  }

  const baseUrl = (api.extra as OtsAsyncThunkConfigExtra).baseUrl;
  const url = `${baseUrl}/object-picture/all/object/${objectId}/download`;

  return window.fetch(url, request)
}

export const {
  useGetAllObjectPictureAssocsByObjectQuery,
  useCreateObjectPictureAssocMutation,
  useUpdateObjectPictureAssocMutation,
  useDeleteObjectPictureAssocMutation,
} = objectPictureAssocApi;
